/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

// state
import { TStore } from '@store/index';
import { StateCreator } from 'zustand';

// datatable sites
import { tableSchemaBase as columns } from '../sites.columns';

// types
import { TColumnsSchema } from '@global-types/index';

/* -------------------------------------------------------------------------- */
/*                                  Interface                                 */
/* -------------------------------------------------------------------------- */
export interface ISitesDatatableSlice {
	sitesDatatableOptions: TColumnsSchema[];
	setSitesDatatableOptions: (
		_sitesDatatableOptions: TColumnsSchema[]
	) => void;
}

/* -------------------------------------------------------------------------- */
/*                                    Slice                                   */
/* -------------------------------------------------------------------------- */

export const partializeSitesDatatableSlice = (
	s: any
): any => ({
	sitesDatatableOptions: s.sitesDatatableOptions,
});

const initialState = {
	sitesDatatableOptions: columns.filter(
		(item) => item.defaultVisible
	),
};

export const createSitesDatatableSlice: StateCreator<
	TStore,
	[['zustand/persist', any]],
	[],
	ISitesDatatableSlice
> = (set) => ({
	...initialState,
	setSitesDatatableOptions: (
		_sitesDatatableOptions: TColumnsSchema[]
	) =>
		set({
			sitesDatatableOptions: _sitesDatatableOptions,
		}),
});
